export default __webpack_public_path__ + "static/rovo-thinking-skeleton-light-c59b11441ec1a5fac69fa3498d4b6e0d.png";